// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"6218fc43","312":"915d5233","739":"6218fc43","756":"2c00cf2e"}[chunkId] + ".chunk.css";
};